var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 100,
    viewBox: "0 0 144 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9056 5.4054H68.2528V8.1081H95.0186V18.9189H105.725V89.1892H56.7063V91.8919H108.402V17.0135L96.9056 5.4054ZM97.6952 16.2162V10.0135L103.838 16.2162H97.6952Z",
    fill: "#87949E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8698 77.027C54.8698 71.8108 50.6676 67.5676 45.5018 67.5676C40.336 67.5676 36.1337 71.8108 36.1337 77.027V81.0811H33.4572V100H57.5464V81.0811H54.8698V77.027ZM38.8103 77.027C38.8103 73.2973 41.8081 70.2703 45.5018 70.2703C49.1955 70.2703 52.1932 73.2973 52.1932 77.027V81.0811H38.8103V77.027ZM54.8698 97.2973H36.1337V83.7838H54.8698V97.2973Z",
    fill: "#1A5BD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.372 75.6757H73.6062V78.3784H100.372V75.6757Z",
    fill: "#87949E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0186 81.0811H60.223V83.7838H95.0186V81.0811Z",
    fill: "#87949E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6358 70.2703H78.9592V72.973H81.6358V70.2703Z",
    fill: "#87949E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2828 70.2703H73.6062V72.973H76.2828V70.2703Z",
    fill: "#87949E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.372 70.2703H84.3125V72.973H100.372V70.2703Z",
    fill: "#87949E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.372 81.0811H97.6953V83.7838H100.372V81.0811Z",
    fill: "#87949E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1637 0V64.8649H46.8403V2.7027H52.1934V30.2703L58.8849 23.5135L65.5764 30.2703V2.7027H133.294V0H44.1637ZM62.8998 23.7432L58.8849 19.6892L54.87 23.7432V2.7027H62.8998V23.7432Z",
    fill: "#87949E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.372 24.3243H84.3125V27.027H100.372V24.3243Z",
    fill: "#87949E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8996 97.2973H60.223V100H62.8996V97.2973Z",
    fill: "#87949E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144 0H141.323V2.7027H144V0Z",
    fill: "#87949E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.647 0H135.97V2.7027H138.647V0Z",
    fill: "#87949E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02961 89.1892H5.35303V91.8919H8.02961V89.1892Z",
    fill: "#87949E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67658 89.1892H0V91.8919H2.67658V89.1892Z",
    fill: "#87949E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2827 61.2702C83.5778 61.2702 89.4916 55.2987 89.4916 47.9324C89.4916 40.5661 83.5778 34.5946 76.2827 34.5946C68.9876 34.5946 63.0737 40.5661 63.0737 47.9324C63.0737 55.2987 68.9876 61.2702 76.2827 61.2702Z",
    fill: "#1A5BD1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3926 41.3243L73.6863 52.1487L68.1725 46.5811L66.2855 48.5L71.7859 54.0541L73.6863 55.973L86.2796 43.2433L84.3926 41.3243Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.fbea425d.svg";
export { ForwardRef as ReactComponent };